import { render, staticRenderFns } from "./SimpleContainerContentWrapper.vue?vue&type=template&id=4308c535&scoped=true&"
import script from "./SimpleContainerContentWrapper.vue?vue&type=script&lang=js&"
export * from "./SimpleContainerContentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SimpleContainerContentWrapper.vue?vue&type=style&index=0&id=4308c535&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4308c535",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4308c535')) {
      api.createRecord('4308c535', component.options)
    } else {
      api.reload('4308c535', component.options)
    }
    module.hot.accept("./SimpleContainerContentWrapper.vue?vue&type=template&id=4308c535&scoped=true&", function () {
      api.rerender('4308c535', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/wrappers/SimpleContainerContentWrapper.vue"
export default component.exports